/* Keyboard access for the native slideshow pagination. */
(() => {
  const initialize = () => {
    document.querySelectorAll('.mn-seasonal-hero .swiper-pagination').forEach(pagination => {
      if (pagination.dataset.mnKeyboardReady) return;
      pagination.dataset.mnKeyboardReady = 'true';
      const labelBullets = () => {
        pagination.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
          bullet.setAttribute('role', 'button');
          bullet.setAttribute('tabindex', '0');
          bullet.setAttribute('aria-label', 'Show slide ' + (index + 1));
          bullet.setAttribute('aria-current', bullet.classList.contains('swiper-pagination-bullet-active') ? 'true' : 'false');
        });
      };
      labelBullets();
      new MutationObserver(labelBullets).observe(pagination, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      pagination.addEventListener('keydown', event => {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.classList.contains('swiper-pagination-bullet')) {
          event.preventDefault();
          event.target.click();
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
